import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { schaumburgConfig } from "./data";

export default function SchaumburgPage() {
  return <CityPageTemplate config={schaumburgConfig} />;
}